export default {"src":"/_next/static/media/buy-home.a380a1ec.svg","height":544,"width":749};